"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlgoliaIndex = void 0;
const types_1 = require("../types");
const SORT_SEPARATOR = 'sorted_by';
const getLocaleFromString = (locale) => {
    return locale.split('-')[0].toLowerCase();
};
const getAlgoliaIndex = ({ environment, locale, tenant, objectType = types_1.ObjectType.Product, querySuggestionType, sorting, }) => {
    return [
        environment,
        tenant.toLocaleLowerCase(),
        getLocaleFromString(locale),
        querySuggestionType,
        objectType,
        ...(sorting?.field && sorting.order
            ? [SORT_SEPARATOR, sorting?.field, sorting?.order]
            : []),
    ]
        .filter(entry => !!entry)
        .join('_');
};
exports.getAlgoliaIndex = getAlgoliaIndex;
//# sourceMappingURL=getAlgoliaIndex.js.map